/** @deprecated */
export enum ClickOptions {
    STARTOBSERVATION,
    STARTCOMMITMENT,
    DELETECOMMITMENT,
    SAVECOMMITMENT,
    PUBLISHCOMMITMENT,
    CLOSECOMMITMENT,
    UPDATECOMMITMENT,
    ADDOBSERVATION,
    LINKOBSERVATION,
    DELETEOBSERVATION,
    SAVEOBSERVATION,
    PUBLISHOBSERVATION,
    CANCELOBSERVATION,
    CLOSEOBSERVATION,
    SHAREOBSERVATION,
    DELETEKPI,
    CHANGEOPPORTUNITY,
    STARTOBSERVATION_FORCOMMMITMENT,
    STARTCOMMITMENT_WITH_METRIC,
    MANAGE_GOALS,
}
